/* eslint sort-keys: "error" */
/* eslint-env es6 */
import { Themes } from '@sainsburys-tech/bolt'
import { ArgosVocab } from '@sainsburys-tech/bolt-vocab-provider'

const argos = {
  backInStock: {
    key: 'BACK_IN_STOCK_KEY_ARGOS',
    proxyPath: '/product-api/back-in-stock',
    url: 'BACK_IN_STOCK_URL_ARGOS'
  },
  bolt: {
    namespace: 'bolt-v2'
  },
  brandDisplayName: 'Argos',
  bzKey: 'BAZAARVOICE_KEY',
  canonicalBase: 'https://www.argos.co.uk',
  channel: 'ARGOS_UK_WEB',
  genai_reviews_summary: true,
  metaDescription: 'Thousands of products for same day delivery, or fast store collection.',
  tealiumPath: 'argos/main',
  theme: Themes.ArgosTheme,
  vocab: ArgosVocab
}

const ArgosFeatures = {
  ASK_QUESTION: true,
  ASK_TREVOR_ENABLED: true,
  ATT_MODAL_HIDE_CATEGORIES: false,
  ATT_MODAL_HIDE_EXTRAS: false,
  BASE_URL: 'www.argos.co.uk',
  BREADCRUMB: true,
  CATEGORY_EXPERIENCES_TEMPLATE_ENABLED: false,
  CNET: true,
  COMPARISON_ATTRIBUTES: false,
  COMPLETE_THE_LOOK: true,
  CUSTOMER_GENERATED_CONTENT: true,
  DESCRIPTION_CLASS: 'xs-12--none md-7--none xl-8--none',
  EMAIL_ME_BACK: {
    ctaText: 'Email me',
    enabled: true,
    excludedSkus: ['9441804', '8349000', '1130034', '1130041', '1300479', '8349024', '1259465'],
    position: 'deliveryBox',
    proxyPath: argos.backInStock.proxyPath,
    source: 'web_pdp'
  },
  ENERGY_SAVING: true,
  ESSENTIAL_EXTRAS: true,
  FABLE_ATT: true,
  FEATURED_PRODUCTS: true,
  FREQUENTY_BROUHT_TOGETHER: true,
  FULFILMENT_PASS: {
    SHOW_PRODUCT_ELIGIBILITY: true,
    SHOW_PURCHASE_PASS: false
  },
  GO_IN_STORE: true,
  KLARNA_CREDITPLAN: true,
  KLARNA_MESSAGING: {
    dcid:
      'klarna_live_client_MHMtVGopOFZRQShjZFNHYmREOUdWYVFyYURjTk8zWXAsMGM2NjYxYWQtZmU4MS00YWIwLTkxNTYtNzM0NjRjYzA2MGZhLDEsNFpoRFliRUVuTFBnc2NhaFgyUFZTQ1BPL0xBSjJUWkNEODFtUnNJQkxtTT0',
    enabled: true
  },
  MEDIA_CLASS: 'xs-12--none md-7 xl-8',
  MEDIA_PORTRAIT: false,
  MONTHLY_PAYMENT_PLAN: true,
  NECTAR: true,
  PAYPAL_IFC_MESSAGING: true,
  PAYPAL_MESSAGING: true,
  PDP_V2_ENABLED: true,
  PRICING_CLASS: 'xs-12--none md-5--none xl-4--none',
  Q_AND_A: true,
  REVIEWS: false,
  REVIEWS_WRITE_REVIEW_ENABLED: false,
  SHOP_COLLECTION: true,
  SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION: true,
  SOLD_BY_ARGOS: false,
  SPECIFICATION_TABLE: false,
  STICKY_BAR: true,
  TEMPLATE_TYPE: 'ARGOS',
  WISHLIST: true
}

export { argos }
export default ArgosFeatures
